import '../css/UserButton.css';
import {logUserButtonClick} from '../api/logUserButtonClick.js';

export const userButton = (userId, buttonId, url, text) => {
  const isLong = text.length > 41; // ✅ simple condition
  const classNames = `user-button${isLong ? " long-button" : ""}`;

 return (
  <a
    href={url}
    target="_self"
    rel="follow"
    className={classNames}
    onClick = {(e)=>logUserButtonClick(userId, buttonId, url)}
    >{text}
    </a>
    );
};


//export const logUserButtonClick = async (userId, buttonId) => {
